import day from '@_plugins/dayjs';
import {
  Customer,
  CustomerHttp,
  SiteAttributes,
  SiteAttributesHttp,
} from '@data/models/customer.interface';
import dayjs from 'dayjs';

// eslint-disable-next-line complexity
export const toCustomer = (customer: Partial<CustomerHttp>): Customer => {
  return {
    id: customer.id || '',
    atlasId: customer.attributes?.atlas_id || '',
    name: customer.attributes?.company_name || '',
    code: customer.attributes?.code || '',
    SIRET: customer.attributes?.siret || '',
    city: customer.attributes?.city || '',
    postalCode: customer.attributes?.postal_code || '',
    registrationNumber: customer.attributes?.registration_number || '',
    agreementNumber: customer.attributes?.agreement_number || '',
    groupCode: customer.attributes?.group_code || '',
    agreementEndDate: customer.attributes?.agreement_end_date
      ? day(customer.attributes?.agreement_end_date)
      : null,
    typology: customer.attributes?.typology || '',
    sites: customer.attributes?.sites?.map(toSite) || [],
    createdAt: day(customer.attributes?.createdAt),
    updatedAt: day(customer.attributes?.updatedAt),
  };
};

export const fromStoredSearchCustomer = ({
  SIRET,
  name,
}: Pick<Customer, 'SIRET' | 'name'>): Customer => {
  return {
    atlasId: '',
    code: '',
    SIRET: SIRET,
    city: '',
    createdAt: dayjs(),
    id: '',
    name: name,
    postalCode: '',
    registrationNumber: '',
    agreementNumber: '',
    groupCode: '',
    agreementEndDate: dayjs(),
    sites: [],
    typology: '',
    updatedAt: dayjs(),
  };
};

export const toSite = (site: SiteAttributesHttp): SiteAttributes => {
  return {
    address: site.address,
    city: site.city,
    code: site.code,
    postalCode: site.postal_code,
    name: site.name,
    phone: site.phone,
  };
};
